import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from "@angular/common/http";
import {Observable} from "rxjs";
import {MvsCrudService} from "features/core/shared/service/crud/mvs-crud.service";
import {HelpCategoryDto} from "../../model/dto/help-category.dto";

@Injectable({
    providedIn: 'root'
})
export class HelpCategoryService {

    private readonly apiUrl: string;

    constructor(private http: HttpClient) {
        this.apiUrl = MvsCrudService.baseUrl + '/cb/help/categories';
    }

    getCategoryTree(moduleAlias: string): Observable<HelpCategoryDto[]> {
        return this.http.get<HelpCategoryDto[]>(this.apiUrl, {
            params: new HttpParams().set('moduleAlias', moduleAlias)
        });
    }

    getCategory(id: number): Observable<HelpCategoryDto> {
        return this.http.get<HelpCategoryDto>(`${this.apiUrl}/${id}`);
    }

    createCategory(category: Partial<HelpCategoryDto>): Observable<HelpCategoryDto> {
        return this.http.post<HelpCategoryDto>(this.apiUrl, category);
    }

    updateCategory(id: number, category: Partial<HelpCategoryDto>): Observable<HelpCategoryDto> {
        return this.http.put<HelpCategoryDto>(`${this.apiUrl}/${id}`, category);
    }

    deleteCategory(id: number): Observable<void> {
        return this.http.delete<void>(`${this.apiUrl}/${id}`);
    }
}
